export enum UnitType {
  LITER = 'liter',
  LITER_PER_DAY = 'literPerDay',
  M3 = 'm3',
  KWH = 'kwh',
  MWH = 'mwh',
  GWH = 'gwh',
}
